import { AssetManager } from './AssetManager'

export const assetManager = new AssetManager()
